(function () {
  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(value).replace(".00", "");
  };

  const root = document.documentElement;
  root.classList.remove("no-js");
  root.classList.add("js");

  const getCart = () => fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());

  const renderCart = (cart) => {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll("[data-cart-subtotal]").forEach((el) => {
      el.textContent = money(cart.total_price);
    });

    const lines = document.querySelector("[data-cart-lines]");
    if (!lines) return;

    if (!cart.items.length) {
      lines.innerHTML = `<div class="cart-empty"><div class="tin" style="width:96px;height:96px;margin:0 auto 18px"><div class="gleam"></div><div class="lip"><div class="caviar pearls" style="border-radius:50%"></div></div></div><p class="h-sm" style="margin-bottom:6px">Your cart is empty</p><p class="small" style="margin-bottom:20px">The dinner party hasn't started yet.</p></div>`;
    } else {
      lines.innerHTML = cart.items.map((item, index) => `
        <div class="cart-line" data-line="${index + 1}">
          <div class="cart-thumb tin"><div class="gleam"></div><div class="lip"><div class="caviar pearls" style="border-radius:50%"></div></div></div>
          <div style="flex:1;min-width:0">
            <div class="between" style="align-items:flex-start">
              <div>
                <p style="font-weight:500">${item.product_title}</p>
                <p class="small">${item.variant_title || item.properties?._pack || ""}</p>
              </div>
              <button class="cart-x" type="button" aria-label="Remove" data-cart-remove="${index + 1}">×</button>
            </div>
            <div class="between" style="margin-top:10px">
              <div class="stepper">
                <button type="button" aria-label="Decrease" data-cart-change="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button>
                <span class="tnum">${item.quantity}</span>
                <button type="button" aria-label="Increase" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}">+</button>
              </div>
              <span class="tnum" style="font-weight:500">${money(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      `).join("");
    }

    const threshold = Number(document.body.dataset.freeSpoonThreshold || 85) * 100;
    const pct = threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 0;
    document.querySelectorAll("[data-cart-meter]").forEach((el) => {
      el.style.width = `${pct}%`;
    });
    document.querySelectorAll("[data-cart-reward]").forEach((el) => {
      if (cart.total_price >= threshold) {
        el.innerHTML = "Free delivery <b>+ a free mother-of-pearl spoon</b> unlocked";
      } else {
        el.innerHTML = `Add <b>${money(threshold - cart.total_price)}</b> for a <b>free mother-of-pearl spoon</b>`;
      }
    });
  };

  const openCart = () => {
    const drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    getCart().then(renderCart);
  };

  const closeCart = () => {
    const drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  document.addEventListener("click", (event) => {
    const open = event.target.closest("[data-open-cart]");
    if (open) {
      event.preventDefault();
      openCart();
      return;
    }

    if (event.target.closest("[data-close-cart]")) {
      event.preventDefault();
      closeCart();
      return;
    }

    const change = event.target.closest("[data-cart-change]");
    const remove = event.target.closest("[data-cart-remove]");
    if (change || remove) {
      event.preventDefault();
      const line = (change || remove).dataset.cartChange || (change || remove).dataset.cartRemove;
      const quantity = remove ? 0 : Number(change.dataset.quantity);
      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: Number(line), quantity })
      }).then((r) => r.json()).then(renderCart);
    }
  });

  document.addEventListener("submit", (event) => {
    const form = event.target.closest("[data-product-form]");
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector("[type='submit']");
    const error = form.querySelector("[data-product-form-error]");
    button && button.classList.add("is-loading");
    error && (error.textContent = "");
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: new FormData(form)
    })
      .then((response) => response.ok ? response.json() : response.json().then((json) => Promise.reject(json)))
      .then(() => getCart())
      .then((cart) => {
        renderCart(cart);
        openCart();
      })
      .catch((err) => {
        if (error) error.textContent = err.description || "Unable to add this item to cart.";
      })
      .finally(() => button && button.classList.remove("is-loading"));
  });

  document.addEventListener("change", (event) => {
    const selector = event.target.closest("[data-bundle-selector]");
    if (!selector) return;
    const card = selector.closest("[data-buybox]");
    if (!card) return;
    card.querySelectorAll(".bsel").forEach((el) => {
      const input = el.querySelector("[data-bundle-selector]");
      el.classList.toggle("on", input && input.checked);
    });
    card.querySelectorAll("[data-bundle-panel]").forEach((panel) => {
      panel.hidden = panel.dataset.bundlePanel !== selector.value;
    });
  });

  document.querySelectorAll("[data-accordion]").forEach((root) => {
    root.addEventListener("click", (event) => {
      const head = event.target.closest("[data-accordion-head]");
      if (!head) return;
      const item = head.closest(".acc");
      const open = item.classList.toggle("open");
      head.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  document.querySelectorAll("[data-tabs]").forEach((tabs) => {
    tabs.addEventListener("click", (event) => {
      const tab = event.target.closest("[data-tab]");
      if (!tab) return;
      const target = tab.dataset.tab;
      tabs.querySelectorAll("[data-tab]").forEach((el) => el.classList.toggle("on", el === tab));
      tabs.querySelectorAll("[data-tab-panel]").forEach((el) => {
        el.hidden = el.dataset.tabPanel !== target;
      });
    });
  });

  getCart().then(renderCart);
})();
